import {
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Dialog,
} from "@mui/material";
import React from "react";

const DialogFC = ({
  children,
  onClose,
  open,
}: {
  children: React.ReactElement | React.ReactElement[];
  open: boolean;
  onClose(): void;
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {children}
    </Dialog>
  );
};

DialogFC.Confirm = ({
  description,
  onCancel,
  title,
  onOk,
}: {
  title: string;
  description: string;
  onCancel(): void;
  onOk(): void;
}) => {
  return (
    <React.Fragment>
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onOk} autoFocus>
          Ok
        </Button>
      </DialogActions>
    </React.Fragment>
  );
};

export default DialogFC;
